var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _g3, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailConfirmed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 455,
    height: 163
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__a",
    x1: "0%",
    x2: "128.043%",
    y1: "50%",
    y2: "43.913%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#42CAC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.293%",
    stopColor: "#2C8EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2B8CAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__b",
    x1: "128.043%",
    x2: "50%",
    y1: "35.871%",
    y2: "59.686%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#42CAC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.293%",
    stopColor: "#2C8EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2B8CAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__c",
    x1: "79.789%",
    x2: "-6.968%",
    y1: "28.225%",
    y2: "102.363%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7FE8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2AA0C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__e",
    x1: "85.826%",
    x2: "-6.968%",
    y1: "49.628%",
    y2: "50.419%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#39A6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#198DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__g",
    x1: "85.276%",
    x2: "35.624%",
    y1: "49.974%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44B9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#64A6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__i",
    x1: "77.125%",
    x2: "-6.968%",
    y1: "36.4%",
    y2: "89.852%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6DC4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2AA0C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__k",
    x1: "119.191%",
    x2: "50%",
    y1: "-34.467%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3071B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#074452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__l",
    x1: "77.125%",
    x2: "-50.461%",
    y1: "47.805%",
    y2: "59.233%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#148BA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2AA0C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__m",
    x1: "54.51%",
    x2: "42.196%",
    y1: "19.354%",
    y2: "103.092%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#48BAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2A99C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__n",
    x1: "77.125%",
    x2: "-6.968%",
    y1: "49.701%",
    y2: "50.876%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6DC4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2AA0C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__o",
    x1: "77.125%",
    x2: "-6.968%",
    y1: "49.625%",
    y2: "51.1%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6DC4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2AA0C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__p",
    x1: "0%",
    x2: "69.011%",
    y1: "114.658%",
    y2: "10.035%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#64D1E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "detail-confirmed_svg__q",
    x1: "50%",
    x2: "50%",
    y1: "-58.271%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F79131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F1C82B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "detail-confirmed_svg__d",
    d: "M.155.58h146.098v12.61H.155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "detail-confirmed_svg__h",
    d: "M.673.992h47.785v40.233H.673z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__a)",
    d: "M9.833 90.983c52.948-15.155 100.935-9.053 143.962 18.305 43.026 27.358 76.769 43.062 101.228 47.112H.541",
    transform: "matrix(-1 0 0 1 256.065 .5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__b)",
    d: "M115.972 159.236c3.553-29.212 21.506-43.819 53.86-43.819 48.531 0 52.517-41.408 85.15-57.729 32.634-16.32 44.764 10.77 80.273-13.6 35.509-24.37 61.68-45.243 99.871-26.183C460.586 30.61 460.211 77.643 434 159l-318.028.236z",
    transform: "translate(.5 .5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#221B44",
    strokeWidth: 1.035,
    d: "M250.269 97.958c15.235 8.49 30.096 9.82 44.584 3.988m-44.584-11.233c15.235 8.49 30.096 9.82 44.584 3.989"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#979797",
    strokeWidth: 0.838,
    d: "M362.5 43.992h-15.09V68.06h15.09V43.992z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__c)",
    d: "M9.641 11.01h137.476v132.679H9.641z",
    transform: "translate(276.57 15.793)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#038998",
    d: "M286.211 26.803h137.476v14.191H286.211z",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(281.745 25.108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "detail-confirmed_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#detail-confirmed_svg__d"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#detail-confirmed_svg__e)",
    xlinkHref: "#detail-confirmed_svg__d"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.484,
    mask: "url(#detail-confirmed_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#247B8C",
    d: "M-24.331 4.956h189.439"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#detail-confirmed_svg__g)",
    d: "M.509 1.644h189.439",
    transform: "translate(-24.84 2.07)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.484,
    mask: "url(#detail-confirmed_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#247B8C",
    d: "M-24.331 10.131h189.439"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#detail-confirmed_svg__g)",
    d: "M.509 1.644h189.439",
    transform: "translate(-24.84 7.245)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(330.39 118.257)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "detail-confirmed_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#detail-confirmed_svg__h"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#detail-confirmed_svg__i)",
    xlinkHref: "#detail-confirmed_svg__h"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.484,
    mask: "url(#detail-confirmed_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#247B8C",
    d: "M-69.27 13.726h189.439"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#detail-confirmed_svg__g)",
    d: "M.509 1.644h189.439",
    transform: "translate(-69.779 10.84)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.484,
    mask: "url(#detail-confirmed_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#247B8C",
    d: "M-69.27 19.935h189.439"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#detail-confirmed_svg__g)",
    d: "M.509 1.644h189.439",
    transform: "translate(-69.779 17.049)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.484,
    mask: "url(#detail-confirmed_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#247B8C",
    d: "M-69.27 26.145h189.439"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#detail-confirmed_svg__g)",
    d: "M.509 1.644h189.439",
    transform: "translate(-69.779 23.259)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.484,
    mask: "url(#detail-confirmed_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#247B8C",
    d: "M-69.27 32.355h189.439"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#detail-confirmed_svg__g)",
    d: "M.509 1.644h189.439",
    transform: "translate(-69.779 29.469)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.484,
    mask: "url(#detail-confirmed_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#247B8C",
    d: "M-69.27 37.53h189.439"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#detail-confirmed_svg__g)",
    d: "M.509 1.644h189.439",
    transform: "translate(-69.779 34.644)"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#038998",
    d: "M331.062 119.249h47.785v7.976h-47.785z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#detail-confirmed_svg__k)",
    transform: "translate(289.027 129.43)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.587,
    cy: 11.371,
    r: 10.246
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.722,
    cy: 12.119,
    r: 8.888
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.834,
    cy: 12.406,
    r: 6.532
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.701,
    cy: 14.476,
    r: 10.246
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.836,
    cy: 9.014,
    r: 8.888
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.947,
    cy: 12.406,
    r: 6.532
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__l)",
    d: "M11.031 125.488h43.461v18.2H.682v-7.85c0-5.716 4.633-10.35 10.35-10.35zm91.246 0h43.461c5.716 0 10.35 4.634 10.35 10.35v7.85h-53.81v-18.2z",
    transform: "translate(276.57 15.793)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#91F6FF",
    d: "M334.788 40.791h2.07v76.589h-2.07zm38.294 0h2.07v76.589h-2.07z",
    opacity: 0.396
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__m)",
    d: "M59.522 2.387h37.725v105.057H59.522z",
    transform: "translate(276.57 15.793)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#207C91",
    d: "M348.242 39.433h13.413v19.393h-13.413z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#72D9EF",
    d: "M348.242 39.433h13.413v9.696h-13.413z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M347.159 39.433h15.579v1.492h-15.579zm0 18.647h15.579v1.492h-15.579z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#207C91",
    d: "M348.242 71.474h13.413v19.393h-13.413z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#72D9EF",
    d: "M348.242 71.474h13.413v9.696h-13.413z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M347.159 71.474h15.579v1.492h-15.579zm0 18.647h15.579v1.492h-15.579z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#038998",
    d: "M331.711 16.536h46.487v7.493h-46.487z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__n)",
    d: "M55.141.743h46.487v5.802H55.141z",
    transform: "translate(276.57 15.793)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#038998",
    d: "M342.033 115.31h24.84v2.07h-24.84z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__o)",
    d: "M49.87 101.227h57.018v7.976H49.87z",
    transform: "translate(276.57 15.793)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__p)",
    d: "M65.411 119.74h26.786v23.949H65.411z",
    transform: "translate(276.57 15.793)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#247B8C",
    strokeWidth: 0.838,
    d: "M354.892 135.877v23.337"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#221B44",
    d: "M248.054 84.691h3.996v73.484h-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221B44",
    d: "M243.38 153.604h12.748v6.21H243.38z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#221B44",
    strokeWidth: 1.035,
    d: "M241.444 97.406h16.251m-13.146-7.018h11.385"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M391.338 56.076h13.106V76.39h-13.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M392.643 56.076h10.497V76.39h-10.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#207C91",
    d: "M392.643 56.076h10.497V76.39h-10.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__q)",
    d: "M4.329 2.108h10.497v10.157H4.329z",
    transform: "translate(388.314 53.968)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M389.415 55.438h17.144v1.593h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M389.415 55.438h17.144v1.12h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M388.314 53.968h19.347v1.593h-19.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M388.314 53.968h19.347v1.12h-19.347z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M389.415 76.712h17.144v-1.593h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M389.415 76.712h17.144v-1.12h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M388.314 78.182h19.347v-1.593h-19.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M388.314 78.182h19.347v-1.12h-19.347z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M303.949 56.076h13.106V76.39h-13.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M305.254 56.076h10.497V76.39h-10.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#207C91",
    d: "M305.254 56.076h10.497V76.39h-10.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__q)",
    d: "M4.329 2.108h10.497v10.157H4.329z",
    transform: "translate(300.925 53.968)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M302.026 55.438h17.144v1.593h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M302.026 55.438h17.144v1.12h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M300.925 53.968h19.347v1.593h-19.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M300.925 53.968h19.347v1.12h-19.347z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M302.026 76.712h17.144v-1.593h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M302.026 76.712h17.144v-1.12h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M300.925 78.182h19.347v-1.593h-19.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M300.925 78.182h19.347v-1.12h-19.347z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M391.338 90.23h13.106v20.314h-13.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M392.643 90.23h10.497v20.314h-10.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#207C91",
    d: "M392.643 90.23h10.497v20.314h-10.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__q)",
    d: "M4.329 2.108h10.497v10.157H4.329z",
    transform: "translate(388.314 88.122)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M389.415 89.592h17.144v1.593h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M389.415 89.592h17.144v1.12h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M388.314 88.122h19.347v1.593h-19.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M388.314 88.122h19.347v1.12h-19.347z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M389.415 110.866h17.144v-1.593h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M389.415 110.866h17.144v-1.12h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M388.314 112.336h19.347v-1.593h-19.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M388.314 112.336h19.347v-1.12h-19.347z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M303.949 90.23h13.106v20.314h-13.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M305.254 90.23h10.497v20.314h-10.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#207C91",
    d: "M305.254 90.23h10.497v20.314h-10.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#detail-confirmed_svg__q)",
    d: "M4.329 2.108h10.497v10.157H4.329z",
    transform: "translate(300.925 88.122)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M302.026 89.592h17.144v1.593h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M302.026 89.592h17.144v1.12h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M300.925 88.122h19.347v1.593h-19.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M300.925 88.122h19.347v1.12h-19.347z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M302.026 110.866h17.144v-1.593h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M302.026 110.866h17.144v-1.12h-17.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC4D5",
    d: "M300.925 112.336h19.347v-1.593h-19.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5B6B",
    d: "M300.925 112.336h19.347v-1.12h-19.347z"
  }))))));
}
export default SvgDetailConfirmed;